module.exports = __webpack_public_path__ + "img/tuya1.e5caa353.png";